import * as React from 'react'

import { StoreButtonImage } from './StoreButtonImage.styles'

const GOOGLE_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.wonderschool.mobile'
const GOOGLE_PLAY_STORE_IMAGE =
  'https://ucarecdn.com/a5a6095b-3212-4704-b068-b565aa6908ee/googleplaybadge2x.png'

export default function GooglePlayButton() {
  return (
    <a href={GOOGLE_PLAY_STORE_URL}>
      <StoreButtonImage alt="Get it on Google Play" src={GOOGLE_PLAY_STORE_IMAGE} />
    </a>
  )
}
